/**
 * @file 技术侧的自定义上报，非产品层上报
 * 主要用于分析页面性能数据等
 */
import Vue from 'vue';

function reportFirstScreenVisible() {
  Vue.prototype.firstScreenImageLoaded = true;
  if (!window.hasReportFirstScreenVisible) {
    window.hasReportFirstScreenVisible = true;
  }
}

function notifyFirstScreenImageLoaded() {
  const config = window.magicUiconfig?.[0].items?.[0];
  Vue.prototype.$bus.$emit('first-screen-image-loaded', {
    config,
  });
}

export default () => {
  Vue.prototype.$bus.$on('first-screen-image-loaded', reportFirstScreenVisible);

  // 已经处理过首屏图片加载了
  if (window.hasShowMagicImageWrapper) {
    // 这里需要通知到其他依赖首屏图片的组件
    if (window.firstScreenFinishTimeStamp) {
      // 通过事件去分发通知到其他组件
      notifyFirstScreenImageLoaded();
    } else {
      window.addEventListener('firstScreenImageLoadedEvent', notifyFirstScreenImageLoaded);
    }
  }
};
